import {useRef} from 'react';
import {useScroll} from 'react-use';
import {IconCartFail} from '~/components';

export function CartEmpty({
  onClose,
  layout = 'drawer',
}: {
  onClose?: () => void;
  layout?: 'page' | 'drawer';
}) {
  return (
    <div className="container">
      <section className="grid gap-6 py-6 md:py-16">
        <header className="px-4 flex justify-between items-center h-nav">
          <h2 className="uppercase text-4xl tracking-wider">Ostoskorisi (0)</h2>

          <button
            type="button"
            className="hidden md:flex underline p-4 -m-4 transition text-primary hover:text-primary/50"
            onClick={onClose}
          >
            Jatka ostoksia
          </button>
        </header>
      </section>
      <div className="text-3xl grid gap-6 py-16 text-textInactive justify-center text-center md:gap-10">
        <IconCartFail
          className="justify-self-center w-10 h-10 origin-center"
          customSize={true}
        />
        <span className="justify-self-center">
          Ostoskorissa ei ole tuotteita.
        </span>
      </div>
    </div>
  );
}
